import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listUsers, ManagedUser } from '../../lib/functions';
import { Badge } from '../../components/ui/Badge';
import { Spinner } from '../../components/ui/Spinner';

export function Therapists() {
  const navigate = useNavigate();
  const [therapists, setTherapists] = useState<ManagedUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      setError(null);
      try {
        const users = await listUsers();
        setTherapists(users.filter((u) => u.role === 'therapist'));
      } catch (err) {
        console.error(err);
        setError('Não foi possível carregar os terapeutas. Verifique se você tem acesso de administrador.');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Terapeutas</h1>
          <p className="muted" style={{ margin: 0 }}>
            Cadastre terapeutas e veja os pacientes de cada um.
          </p>
        </div>
        <button className="btn" onClick={() => navigate('/admin/therapists/new')}>
          + Novo terapeuta
        </button>
      </div>

      {error && <div className="card" style={{ borderColor: 'var(--danger)', color: 'var(--danger)' }}>{error}</div>}

      <div className="card">
        {loading ? (
          <div style={{ padding: 24, display: 'flex', justifyContent: 'center' }}>
            <Spinner />
          </div>
        ) : therapists.length === 0 ? (
          <div className="empty-state">Nenhum terapeuta cadastrado ainda.</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Terapeuta</th>
                  <th>Pacientes</th>
                  <th>Situação</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {therapists.map((t) => (
                  <tr
                    key={t.uid}
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate(`/admin/therapists/${t.uid}`)}
                  >
                    <td>
                      <div style={{ fontWeight: 600 }}>{t.displayName ?? t.email ?? t.uid}</div>
                      {t.displayName && <div className="muted" style={{ fontSize: 13 }}>{t.email}</div>}
                    </td>
                    <td>{t.patientCount}</td>
                    <td>
                      {t.disabled ? <Badge variant="danger">Desativado</Badge> : <Badge variant="success">Ativo</Badge>}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <span className="muted">›</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
